import { useEffect, useState, useCallback } from "react";
import { Loader2, Cpu } from "lucide-react";
import api from "../lib/apiClient";

export default function AdminAI() {
  const [days, setDays] = useState(30);
  const [d, setD] = useState(null);
  const load = useCallback(async () => {
    setD(null);
    try { setD((await api.get(`/admin/ai?days=${days}`)).data); } catch { setD({ total: 0, errors: 0, avg_latency_ms: 0, by_feature: {}, by_model: {} }); }
  }, [days]);
  useEffect(() => { load(); }, [load]);
  const Break = ({ title, data, testid }) => (
    <div className="bg-[#18181E] border border-zinc-800 rounded-2xl p-5" data-testid={testid}>
      <h2 className="font-display text-lg font-bold mb-3">{title}</h2>
      {Object.entries(data || {}).length === 0 ? <p className="text-sm text-zinc-500">Aucune donnée.</p> :
        Object.entries(data).map(([k, n]) => <div key={k} className="flex justify-between text-sm py-1"><span className="text-zinc-300">{k}</span><span className="font-mono text-amber-400">{n}</span></div>)}
    </div>
  );
  return (
    <div className="space-y-5" data-testid="admin-ai">
      <div className="flex items-center justify-between">
        <h1 className="font-display text-3xl font-extrabold flex items-center gap-2"><Cpu className="w-7 h-7 text-amber-400" /> AI Control Center</h1>
        <select value={days} onChange={(e) => setDays(Number(e.target.value))} data-testid="ai-period" className="h-10 px-3 bg-zinc-900 border border-zinc-800 rounded-xl text-sm text-zinc-200">
          <option value={7}>7 jours</option><option value={30}>30 jours</option><option value={90}>90 jours</option>
        </select>
      </div>
      {!d ? <div className="flex justify-center py-16"><Loader2 className="w-7 h-7 text-amber-500 animate-spin" /></div> : (
        <>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            <div className="bg-[#18181E] border border-zinc-800 rounded-2xl p-4" data-testid="ai-total"><p className="text-xs text-zinc-500">Requêtes IA</p><p className="text-2xl font-extrabold">{d.total}</p></div>
            <div className="bg-[#18181E] border border-zinc-800 rounded-2xl p-4"><p className="text-xs text-zinc-500">Erreurs</p><p className="text-2xl font-extrabold text-red-400">{d.errors}</p></div>
            <div className="bg-[#18181E] border border-zinc-800 rounded-2xl p-4"><p className="text-xs text-zinc-500">Latence moy.</p><p className="text-2xl font-extrabold">{d.avg_latency_ms} ms</p></div>
          </div>
          <div className="grid md:grid-cols-2 gap-4">
            <Break title="Par fonctionnalité" data={d.by_feature} testid="ai-by-feature" />
            <Break title="Par modèle" data={d.by_model} testid="ai-by-model" />
          </div>
        </>
      )}
    </div>
  );
}
